import { EndpointBuilder } from '@reduxjs/toolkit/dist/query/endpointDefinitions';

export default (build: EndpointBuilder<any, any, any>) =>
  build.mutation<Response, data>({
    query: (body) => ({
      url: `/v3/pitch-owner-app/stadiums/${body.stadiumId}/gallery/${body?.imageId}`,
      method: 'delete',
      body,
    }),
  });

interface data {
  imageId: string;
  stadiumId: number;
}
